<div class="max-w-320 mx-auto px-4 pt-8 sm:px-8 sm:pt-16">
    <div class="grid grid-cols-2">
        <div class="col-span-2 md:col-span-1 max-w-100 w-full mx-auto">
            <a href="https://markoutpro.com" class="text-black rounded-xl dark:text-white no-underline flex items-center mb-8">
                <img src="/assets/images/logo_long.png" class="w-80">
            </a>
        </div>
    </div>
</div>
<router-outlet *ngIf="true"></router-outlet>